import { makeStyles } from '@mui/styles';
import React from 'react';

import EditorForm from './ssEditorForm';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_BORDER_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles({
  changesModeWrapper: {
    display: 'flex',
    marginBottom: 16,
    padding: 8,
    border: FCM_BORDER_STYLES.BLUE,
  },
  form: {
    flexGrow: 1,
  },
});

const SSForm = ({ isEditor, children, isControlChangedFCM, ...props }) => {
  const classes = useStyles();

  if (isEditor) {
    return <EditorForm {...props} />;
  }

  if (isControlChangedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={props.id}>
        <div className={classes.form}>{children}</div>
        <div>
          <ControlChangesIcon id={props.id} />
        </div>
      </div>
    );
  }

  return children;
};

export default SSForm;
